import {
  INITIAL,
  PENDING,
  COMPLETED,
  FAILED,
} from "src/engine/modules/constants"
import get from "lodash/get"
import {
  REQUESTED_FEATURE_LIST,
  REQUESTED_FEATURE_LIST_SUCCEEDED,
  REQUESTED_FEATURE_LIST_FAILED,
} from "../actions/types"

export const INITIAL_STATE = {
  status: INITIAL,
  data: [],
}

export default function featureReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUESTED_FEATURE_LIST:
      return {
        ...state,
        status: PENDING,
      }
    case REQUESTED_FEATURE_LIST_SUCCEEDED:
      return {
        ...state,
        status: COMPLETED,
        data: get(action, `action.data`),
      }
    case REQUESTED_FEATURE_LIST_FAILED:
      return {
        ...state,
        status: FAILED,
        data: [],
      }
    default:
      return state
  }
}
